import React from "react";
import Sell from "../components/Sell";

export default function SellPage() {
  return <Sell />;
}
